import { useQuery } from '@tanstack/react-query';
import { fetchThirdPartyAgreement } from '../services/thirdPartyAgreement';
import { thirdPartyAgreementKeys } from './thirdPartyAgreementKeys';

export function useThirdPartyAgreementQuery(vrm: string, reference: string) {
    return useQuery({
        queryKey: thirdPartyAgreementKeys.detail(vrm, reference),
        queryFn: () => fetchThirdPartyAgreement(vrm, reference),
        enabled: vrm !== '' && reference !== '',
        retry: false,
        refetchOnWindowFocus: false,
    });
}
